import axios from 'axios'
import router from '../router'
import qs from 'qs'

axios.defaults.baseURL = process.env.VUE_APP_API_URL

axios.interceptors.request.use(config => {
  config.paramsSerializer = params => {
    return qs.stringify(params, {
      arrayFormat: 'brackets',
      encode: false,
    })
  }
  return config
})

axios.interceptors.response.use((response) => {
  return response
}, (error) => {
  if (error.response && error.response.status === 403) {
    router.push({ name: 'Forbidden' })
  }
  if (error.response && error.response.status === 401) {
    // router.push({ name: 'Login' })
  }
  return Promise.reject(error)
})

export default axios
